import type { CSSProperties } from 'react';
import { useIntl } from 'react-intl';

import { stages } from '../../config';
import { formatAegStage, type StageKey } from '../../types';
import './styles.css';

type ProgressProps = {
    title: string;
    stageKeys: StageKey[];
    counts: Record<StageKey, number>;
    total: number;
    selected: StageKey | null;
    onSelect: (stage: StageKey) => void;
};

export default function Progress({ title, stageKeys, counts, total, selected, onSelect }: ProgressProps) {
    const intl = useIntl();
    const groupTotal = stageKeys.reduce((sum, stage) => sum + (counts[stage] ?? 0), 0);

    return (
        <section className='aeg-progress-root panel panel-default margin-bottom-0 rounded padding-15 bg-white'>
            <div className='aeg-progress-title display-flex align-items-center justify-content-between'>
                <h2 className='margin-0 text-bold text-color-darkest'>{title}</h2>
                <span className='text-size-12 text-color-dark'>{intl.formatMessage({ id: 'intl-msg:support.aeg.requests.count' }, { count: groupTotal })}</span>
            </div>
            <div aria-hidden='true' className='aeg-progress-bar'>
                {stageKeys.map(stage => (
                    <span
                        key={stage}
                        style={{
                            backgroundColor: stages[stage].color,
                            flexGrow: counts[stage] ?? 0,
                        }}
                    />
                ))}
            </div>
            <div className={`aeg-progress-stage-grid display-grid grid-cols-${stageKeys.length} gap-10 margin-top-10`}>
                {stageKeys.map(stage => (
                    <button
                        className={`aeg-progress-stage bg-lightest ${selected === stage ? 'active' : ''}`}
                        key={stage}
                        onClick={() => onSelect(stage)}
                        style={{ '--stage-color': stages[stage].color } as CSSProperties}
                        type='button'
                    >
                        <b className='text-color-darkest'>
                            {counts[stage] ?? 0}
                            <em className='text-color-dark'>
                                {total > 0 ? Math.round(((counts[stage] ?? 0) / total) * 100) : 0}%
                            </em>
                        </b>
                        <span className='text-color-darker'>{formatAegStage(intl, stage)}</span>
                    </button>
                ))}
            </div>
        </section>
    );
}
